import React from "react";
import Header from "../../appLayout/header";
import "./index.scss";
import { Button, Col, Row } from "react-bootstrap";
import heroImage from "../../../assets/images/img-slide-home.png";
import { ButtonApp } from "../../ButtonApp";
import { useNavigate } from "react-router-dom";
export const SlideHome = () => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate("/apropos");
    window.scrollTo(0, 0); // Navigue vers la page "About"
  };
  const handleNavigationService = () => {
    navigate("/services#services-section");
  };

  return (
    <div className="slide-home">
      <div className="header-home pt-5">
        <Header />
      </div>
      <div className="slide-homer-container  ">
        <Row className="align-items-end justify-content-end gx-0  h-100">
          <Col md={12}>
            <h1 className="slide-title ">
              Votre cabinet de conseil Expert <br className="br-mobile" />
              en Transformation Digitale
            </h1>
            <div className="descri-slide-mobile d-md-none d-block">
              <h3 className="sub-title"> Consultek Votre cabinet de conseil</h3>
              <p className="text-slide">
                {" "}
                Consultek se positionne comme un cabinet de conseil de
                référence, spécialisé dans l'accompagnement des entreprises vers
                l'excellence opérationnelle et technologique.  
              </p>
              <ButtonApp title={"Voir Plus"} handlClick={handleNavigation} />
            </div>

            <div className="hero-image">
              <div className="descri-slide d-none d-md-block">
                <h3 className="sub-title">
                  Consultek Votre cabinet de conseil
                </h3>
                <p className="text-slide">
                  Consultek se positionne comme un cabinet de conseil de
                  référence, spécialisé dans l'accompagnement des entreprises
                  vers l'excellence opérationnelle et technologique.  
                </p>
                <ButtonApp title={"Voir Plus"} handlClick={handleNavigation} />
              </div>
              <button className="btn-service" onClick={handleNavigationService}>
                Nos services
              </button>
              <img
                src={heroImage}
                alt="Consultante digitale"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
